import React, { useId } from 'react'
import PropTypes from 'prop-types'

const BadgeKeyIcon = React.forwardRef(function BadgeKeyIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 9C7.94772 9 7.5 9.44772 7.5 10C7.5 10.5523 7.94772 11 8.5 11C9.05228 11 9.5 10.5523 9.5 10C9.5 9.44772 9.05228 9 8.5 9ZM5.5 10C5.5 8.34315 6.84315 7 8.5 7C10.1569 7 11.5 8.34315 11.5 10C11.5 11.6569 10.1569 13 8.5 13C6.84315 13 5.5 11.6569 5.5 10Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2C1 1.44772 1.44772 1 2 1H22C22.5523 1 23 1.44772 23 2C23 11.1936 20.441 16.4515 17.7399 19.4227C16.3969 20.9 15.0436 21.7837 14.0097 22.3007C13.4934 22.5589 13.0571 22.7253 12.7418 22.8289C12.5841 22.8808 12.4565 22.9169 12.3639 22.941C12.3177 22.953 12.2801 22.962 12.2519 22.9685L12.2168 22.9763L12.2046 22.9789L12.1999 22.9798L12.1979 22.9802C12.197 22.9804 12.1961 22.9806 12 22C11.8039 22.9806 11.803 22.9804 11.8021 22.9802L11.8001 22.9798L11.7954 22.9789L11.7832 22.9763L11.7481 22.9685C11.7199 22.962 11.6823 22.953 11.6361 22.941C11.5435 22.9169 11.4159 22.8808 11.2582 22.8289C10.9429 22.7253 10.5066 22.5589 9.99029 22.3007C8.95641 21.7837 7.60306 20.9 6.26006 19.4227C3.55899 16.4515 1 11.1936 1 2ZM12 22L11.8039 22.9806C11.9333 23.0065 12.0667 23.0065 12.1961 22.9806L12 22ZM12 20.966C12.035 20.9554 12.0743 20.9431 12.1175 20.9289C12.3491 20.8528 12.6941 20.7224 13.1153 20.5118C13.9564 20.0913 15.1031 19.35 16.2601 18.0773C18.4704 15.646 20.8121 11.1686 20.9893 3H3.01073C3.18791 11.1686 5.5296 15.646 7.73994 18.0773C8.89694 19.35 10.0436 20.0913 10.8847 20.5118C11.3059 20.7224 11.6509 20.8528 11.8825 20.9289C11.9257 20.9431 11.965 20.9554 12 20.966Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 10C9.5 9.44772 9.94772 9 10.5 9H17.5C18.0523 9 18.5 9.44772 18.5 10C18.5 10.5523 18.0523 11 17.5 11H10.5C9.94772 11 9.5 10.5523 9.5 10Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 9C16.0523 9 16.5 9.44772 16.5 10V12C16.5 12.5523 16.0523 13 15.5 13C14.9477 13 14.5 12.5523 14.5 12V10C14.5 9.44772 14.9477 9 15.5 9Z"
      ></path>
    </svg>
  )
})

BadgeKeyIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

BadgeKeyIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default BadgeKeyIcon
